<template>
  <simple-wizard
    :nextButtonText="$t('userAccountsSearch.nextButtonText')"
    :prevButtonText="$t('userAccountsSearch.previousButtonText')"
    :finishButtonText="$t('userAccountsSearch.finishButtonText')"
    title=""
    sub-title=""
    @tab-change="tabChangeEvent"
    :loading="accountLoading"
  >
    <template v-if="!hideHeader" slot="header">
      <h3 class="card-title">{{ $t('userAccountsSearch.title') }}</h3>
      <h3 class="description">
        {{ $t('userAccountsSearch.description') }}
      </h3>
    </template>

    <wizard-tab :before-change="() => validateStep('step1')">
      <template slot="label">
        <i class="tim-icons icon-single-02"></i>
        <p>{{ $t('userAccountsSearch.firstStepAction') }}</p>
      </template>
      <first-step
        ref="step1"
        @on-validated="onStepValidated"
        :hide-search-by-serial-number="hideSearchBySerialNumber"
      ></first-step>
    </wizard-tab>

    <wizard-tab :before-change="() => validateStep('step2')">
      <template slot="label">
        <i class="tim-icons icon-settings-gear-63"></i>
        <p>{{ $t('userAccountsSearch.secondStepAction') }}</p>
      </template>
      <second-step
        ref="step2"
        @on-validated="onStepValidated"
        :process-error="processError"
      ></second-step>
    </wizard-tab>

    <!-- <wizard-tab :before-change="() => validateStep('step3')">
      <template slot="label">
        <i class="tim-icons icon-delivery-fast"></i>
        <p>{{ $t('userAccountsSearch.thirdStepAction') }}</p>
      </template>
      <third-step ref="step3"></third-step>
    </wizard-tab> -->
  </simple-wizard>
</template>
<script>
import FirstStep from './SearchWizard/FirstStep.vue';
import SecondStep from './SearchWizard/SecondStep.vue';
import {SimpleWizard, WizardTab} from 'src/components';
import {mapState} from "vuex";

export default {
  data() {
    return {
      wizardModel: {}
    };
  },
  props: {
    hideHeader: {
      type: Boolean
    },
    processError: {
      type: String
    },
    searchStepReopened: {
      type: Function,
      description: "Callback function when account search step was reopened."
    },
    hideSearchBySerialNumber: {
      type: Boolean,
      description: "Will not show search by serial number."
    }
  },
  components: {
    FirstStep,
    SecondStep,
    SimpleWizard,
    WizardTab
  },
  computed: {
    ...mapState({
      accountLoading: state => state.account.loading,
    }),
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = {...this.wizardModel, ...model}
      if (this.wizardModel.validated) {
        this.searchComplete()
      }
    },
    searchComplete() {
      this.$emit('processFoundAccount', {id: this.wizardModel.accountId, type: this.wizardModel.type})
    },
    tabChangeEvent(oldTab, newTab) {
      if (newTab.tabId == "1") {
        // Go back action
        if (this.searchStepReopened != null) {
          // Invoke callback.
          this.searchStepReopened()
        }
        // Need to change wizard that it is not validated.
        this.wizardModel.validated = false;
      }
    }
  }
};
</script>
